import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React, { useRef } from 'react';
import { AddGoalContextMenu } from 'shared/components/connected/add-goal-context-menu';
import { EmptyGoals } from 'shared/components/ui/empty-goals';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { ID } from 'shared/types/id';

import * as Styled from './empty-banner.style';

export type EmptyBannerProps = {
  lifeAreaId?: ID;
};

export const EmptyBanner: React.FC<EmptyBannerProps> = ({ lifeAreaId }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const contextMenuRef = useRef<HTMLDivElement>(null);

  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const { position, open, close } = useContextMenuState();

  const onAdd = (e: React.MouseEvent) =>
    createGoalAllowed ? open(e) : openPremiumDialog();

  return (
    <Styled.EmptyContainer ref={containerRef}>
      <EmptyGoals onAdd={onAdd} buttonRef={buttonRef} />

      {!!position && (
        <AddGoalContextMenu
          ref={contextMenuRef}
          referenceElement={buttonRef}
          position="bottom"
          onClose={close}
          lifeAreaId={lifeAreaId}
        />
      )}
    </Styled.EmptyContainer>
  );
};
